import { styled } from "@mui/material/styles";
import { Typography } from "@mui/material";

import Placeholder from "components/Placeholder";

export const Root = styled("div")({
  width: "100%",
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
});

export const MainInfo = styled("div", {
  shouldForwardProp: (prop) => prop !== "isVertical",
})(({ theme, isVertical }) => ({
  paddingBottom: 60,
  display: "flex",
  width: "100%",
  flexDirection: "column",
  [theme.breakpoints.up("mobile")]: {
    paddingTop: 30,
    paddingBottom: 30,
  },
  [theme.breakpoints.up("tablet")]: {
    paddingTop: 60,
    flexDirection: "row",
    paddingBottom: 60,
    ...(isVertical && {
      justifyContent: "center",
      alignItems: "flex-start",
    }),
  },
}));

export const Video = styled("div", {
  shouldForwardProp: (prop) => prop !== "isVertical",
})(({ theme, isVertical }) => ({
  ...(!isVertical && {
    [theme.breakpoints.up("mobile")]: {
      width: 694,
      margin: "0 auto 30px",
    },
    [theme.breakpoints.up("tablet")]: {
      width: 832,
      margin: 0,
    },
  }),
}));

export const Main = styled("div", {
  shouldForwardProp: (prop) => prop !== "isVertical",
})(({ theme, isVertical }) => ({
  padding: "20px 0",
  display: "flex",
  flexDirection: "column",
  width: "100%",
  [theme.breakpoints.up("mobile")]: {
    padding: 0,
    width: 694,
    margin: "0 auto",
    flexDirection: "row",
    ...(isVertical && {
      flexDirection: "column",
      alignItems: "center",
    }),
  },
  [theme.breakpoints.up("tablet")]: {
    flexDirection: "column",
    width: 312,
    margin: "0 0 100px 60px",
    ...(isVertical && {
      margin: "25px 0 0 0",
      position: "relative",
      left: 120,
    }),
  },
}));

export const Content = styled("div", {
  shouldForwardProp: (prop) => prop !== "isVertical",
})(({ theme, isVertical }) => ({
  marginBottom: 20,
  [theme.breakpoints.up("mobile")]: {
    width: 312,
    marginRight: 60,
    marginBottom: 0,
    ...(isVertical && {
      marginRight: 0,
      marginTop: 20,
      marginBottom: 20,
    }),
  },
  [theme.breakpoints.up("tablet")]: {
    width: "initial",
    marginBottom: 40,
    marginRight: 0,
    ...(isVertical && {
      marginTop: 0,
    }),
  },
}));

export const Title = styled(Typography)(({ theme }) => ({
  marginBottom: 10,
  [theme.breakpoints.up("mobile")]: {
    textAlign: "left",
    marginBottom: 20,
  },
}));

export const TitlePlaceholder = styled(Placeholder)(({ theme }) => ({
  marginBottom: 10,
  [theme.breakpoints.up("mobile")]: {
    textAlign: "left",
    marginBottom: 20,
  },
}));

export const FitTitle = styled("div")(({ theme }) => ({
  maxHeight: 55,
  [theme.breakpoints.up("mobile")]: {
    maxHeight: "auto",
  },
}));

export const Description = styled(Typography)(({ theme }) => ({
  textAlign: "center",
  [theme.breakpoints.up("mobile")]: {
    textAlign: "left",
    fontSize: theme.typography.large.fontSize,
  },
  "& .custom-description-link": {
    color: theme.palette.delete.main,
    "&:hover": {
      textDecoration: "underline",
    },
  },
}));

export const DescriptionPlaceholder = styled(Placeholder)(({ theme }) => ({
  textAlign: "center",
  [theme.breakpoints.up("mobile")]: {
    textAlign: "left",
    fontSize: theme.typography.large.fontSize,
  },
}));

export const FitDescription = styled("div", {
  shouldForwardProp: (prop) => prop !== "isPromoTemplates",
})(({ theme, isPromoTemplates }) => ({
  ...(!isPromoTemplates && {
    maxHeight: 65,
    [theme.breakpoints.up("mobile")]: {
      maxHeight: "auto",
    },
  }),
}));

export const Actions = styled("div")(({ theme }) => ({
  textAlign: "center",
  [theme.breakpoints.up("mobile")]: {
    flex: 1,
  },
}));

export const CastPlaceholder = styled(Placeholder)(({ theme }) => ({
  padding: "0 10px 20px",
  [theme.breakpoints.up("mobile")]: {
    fontSize: theme.typography.large.fontSize,
    padding: "0 10px 30px",
  },
  [theme.breakpoints.up("tablet")]: {
    padding: "0 10px 40px",
  },
}));

export const ButtonPlaceholder = styled(Placeholder)({});

export const ButtonWrapper = styled("div", {
  shouldForwardProp: (prop) => prop !== "isVertical",
})(({ theme, isVertical }) => ({
  ...(isVertical && {
    [theme.breakpoints.up("mobile")]: {
      "& button": {
        width: 310,
      },
    },
  }),
}));
